/* global DetailsDisclosure */

if (!customElements.get('m-details-disclosure')) {
  class MDetailsDisclosure extends DetailsDisclosure {
    close() {
      this.addContentHeight();
      setTimeout(() => {
        this.panel.style.height = '0';
        this.disclosure.open = false;
        this.focus();
      });
    }
  }

  customElements.define('m-details-disclosure', MDetailsDisclosure);
}
